import React from 'react';
import { Grid, Button } from '@material-ui/core';
import { AddBox } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useAddItemToolbarStyles } from './style';

export function AddItemToolbar(props: any) {
  const { t } = useTranslation();
  const styles = useAddItemToolbarStyles();

  return (
    <Grid container direction='row' className={styles.container}>
      <Grid item>
        <Button
          className={styles.button}
          variant='outlined'
          onClick={() => {
            props.actions[0].onClick();
          }}
          startIcon={<AddBox />}
        >
          {t('new')}
        </Button>
      </Grid>
    </Grid>
  );
}
